// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.temp-number[data-v-4748ef64] {\n  font-style: italic;\n}\n", ""]);
// Exports
module.exports = exports;
